import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CommonOrCommonRetirementFlug,
  DispDepositType,
  Status,
} from "../../assets/data/Constants";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_REC021_Response } from "../../type/apiType";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode } from "../../utils/TkGetCode";
import { httpAPI_APP016, httpAPI_REC021, httpAPI_REC022 } from "./api/request";
import { fakeTableList, headList, schema } from "./parts";
import "./_style.scss";
import _ from "lodash";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW160007 新規振込先金融機関登録
 * @return SCRW160007 新規振込先金融機関登録
 */
const SCRW160007 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const [latestApplyStatus, setLatestApplyStatus] =
    useState<ITkViewButtonJudgementStatus>();
  const [responseData, setResponseData] = useState<IAPI_REC021_Response>({});
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const applyId = location.state?.applyId;

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    let resArr = [...stateFakeTableListRef.current];

    if (applyId) {
      try {
        const res = await httpAPI_REC021({
          applyId,
        });

        if (res.resultCd === "I0000") {
          setResponseData(res);
          setLatestApplyStatus(
            res.latestApplyStatus as ITkViewButtonJudgementStatus
          );

          let disabled = true;
          if (
            res.latestApplyStatus === Status["届出待ち"] ||
            res.latestApplyStatus === Status["差戻し一時保存"]
          ) {
            disabled = false;
          } else if (!applyId) {
            disabled = false;
          }

          let memoList = res.statusList?.map((item: any) => [
            {
              children: item.managerName,
            },
            {
              children: item.process,
            },
            {
              children: item.createDate,
            },
            {
              children: item.processComment,
            },
          ]);

          // メモ
          let memo = resArr.find((item) => item.keyword === "memo")!;
          memo.showLine = (disabled);
          memo.node = (
            <Box className="memo">
              <TkMemo bodyList={memoList} onChange={onChange} />
            </Box>
          );

          // 決裁日・記号番号
          let approvalDateAndsymbolNo = resArr.find(
            (item) => item.keyword === "approvalDateAndsymbolNo"
          )!;
          let bodyList = [
            [{ children: res.approvalDate }, { children: res.symbolNo }],
          ];
          approvalDateAndsymbolNo.node = (
            <TkTableWithNoLine headList={headList} bodyList={bodyList} />
          );
          approvalDateAndsymbolNo.showLine = isStatusAfterApproval(
            res.latestApplyStatus
          );

          // 区分の表示
          const paymentKbn = resArr.find(
            (item) => item.keyword === "paymentKbn"
          )!;
          paymentKbn.setDefaultValue = res.paymentKbn;
          paymentKbn.disabled = disabled;
          //振込先の表示
          const billingName = resArr.find(
            (item) => item.keyword === "billingName"
          )!;
          billingName.setDefaultValue = res.billingName;
          billingName.disabled = disabled;
          //預金種目の表示
          const depositType = resArr.find(
            (item) => item.keyword === "depositType"
          )!;

          if (
            res.latestApplyStatus === Status["届出待ち"] ||
            res.latestApplyStatus === Status["差戻し一時保存"]
          ) {
            depositType.setDefaultValue = DispDepositType["普通"];
          } else {
            res.depositType === DispDepositType["普通"] &&
              (depositType.setDefaultValue = DispDepositType["普通"]);
          }
          //摘要の表示
          const refComment = resArr.find(
            (item) => item.keyword === "refComment"
          )!;
          refComment.setDefaultValue = res.refComment;
          refComment.disabled = disabled;
          //金融機関の表示
          resArr.find((item) => item.keyword === "bankSelect")!.buttonDisabled =
          disabled;

          resArr.find((item) => item.keyword === "bankCd")!.text = res.bankCd;

          resArr.find((item) => item.keyword === "branchCd")!.text =
            res.branchCd;

          resArr.find((item) => item.keyword === "bankName")!.text =
            res.bankName;

          resArr.find((item) => item.keyword === "branchName")!.text =
            res.branchName;
          //口座番号の表示
          const accountNo = resArr.find(
            (item) => item.keyword === "accountNo"
          )!;
          accountNo.setDefaultValue = res?.accountNo;
          accountNo.disabled = disabled;
          //口座名義人（半角ｶﾀｶﾅ）の表示
          const accountHolderKana = resArr.find(
            (item) => item.keyword === "accountHolderKana"
          )!;
          accountHolderKana.setDefaultValue = res?.accountHolderKana;
          accountHolderKana.disabled = disabled;
          //金額の表示
          const transferAmount = resArr.find(
            (item) => item.keyword === "transferAmount"
          )!;
          transferAmount.setDefaultValue = res.transferAmount;
          transferAmount.disabled = disabled;
          //振込予定日の表示
          const transferDay = resArr.find(
            (item) => item.keyword === "transferDay"
          )!;
          transferDay.setDefaultValue = res?.transferDay;
          transferDay.disabled = disabled;

          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch {
        navigate("/error");
      }
    } else {
      resArr.find((item) => item.keyword === "depositType")!.setDefaultValue =
        DispDepositType["普通"];
    }

    setStateTableList([...resArr]);
  };

  useEffect(() => {
    let resArr = [...stateFakeTableListRef.current];
    let bankSelection = resArr.find((item) => item.keyword === "bankSelect")!;

    // 金融機関検索
    bankSelection.onSuccessfulWithBank = (value: any) => {
      resArr.find((item) => item.keyword === "bankCd")!.text = value.bankCode;
      resArr.find((item) => item.keyword === "bankName")!.text =
        value.bankNameKatakana;
      resArr.find((item) => item.keyword === "branchCd")!.text =
        value.branchCode;
      resArr.find((item) => item.keyword === "branchName")!.text =
        value.branchNameKatakana;
      setStateTableList([...resArr]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    }
    if (event.target.type === "checkbox") {
      setMemoCheck(event.target.value);
    }
  };
  const btnEvent = async (btnName: any) => {
    switch (btnName) {
      case "受理":
        updateStatus("2");
        break;
      case "承認":
        setIsOpen(true);
        break;
      case "担当者に差戻し":
        if (latestApplyStatus === "01" || latestApplyStatus === "02") {
          updateStatus("5");
        } else {
          updateStatus("8");
        }
        break;
      case "上長承認":
        updateStatus("6");
        break;
      case "郵送":
        updateStatus("11");
        break;
      case "課長代理確認":
        updateStatus("14");
        break;
      default:
        return;
    }
  };
  const updateStatus = async (status: any) => {
    try {
      const res = await httpAPI_APP016({
        applyId: applyId,
        applyEvent: status,
        contractorNo: businessState.common?.contractorNo,
        reason: memoData,
        inquiryCode: memoCheck ? "3" : "",
        screenId: "SCRW160007",
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const onCheckAndSubmit = async (data: any) => {
    //振込情報申請更新API実行
    try {
      const res = await httpAPI_REC022({
        paymentKbn: data.paymentKbn, // 支払区分
        billingName: data.billingName, // 振込先
        refComment: data.refComment, // 適用
        bankCd: data.bankSelect.bankCode, // 金融機関コード
        bankName: data.bankSelect.bankNameKatakana, // 金融機関名
        branchCd: data.bankSelect.branchCode, // 支店コード
        branchName: data.bankSelect.branchNameKatakana, // 支店名
        depositType: data.depositType, // 預金種目
        accountNo: data.accountNo, // 口座番号
        accountHolderKana: data.accountHolderKana, // 口座名義ｶﾅ
        transferDay: data.transferDay, // 振込予定日
        transferAmount: data.transferAmount, // 金額
        applyId: applyId, // 申請id
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW160006");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleSave = async (data: any) => {
    try {
      const res = await httpAPI_APP016({
        applyId: applyId,
        applyEvent: "3",
        contractorNo: businessState.common?.contractorNo,
        decisionDate: data.settlementDate,
        symbolNo:
          TkGetCode(CommonOrCommonRetirementFlug, data.symbolNumberType) +
          "第" +
          data.symbolNumber +
          "号",
        reason: memoData,
        inquiryCode: memoCheck ? "3" : "",
        screenId: "SCRW160007",
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };
  return (
    <Box className="SCRW160007" data-testid="SCRW160007PageIdForTest">
      {applyId && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-14"
          corporateApplicationClassification={responseData.corpApplyKbn as any}
          applicationStatus={latestApplyStatus}
          data-testid="stepper"
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        onCheckAndSubmit={(data) => onCheckAndSubmit(data)}
        buttonGroup={
          <Box>
            <TkBackButton
              className={applyId ? "tkBottonMr" : ""}
              useBackParam
              navigateParam={{ applyId }}
            />
            {applyId && (
              <TkViewButtonJudgement
                flowType="TYPE2"
                businessType="JOB-14"
                Status={latestApplyStatus}
                onClick={btnEvent}
                data-testid="TkViewButtonJudgement"
              />
            )}
          </Box>
        }
        submitButtonGroup={[{ submitButtonText: "登録", showButton: (!applyId||latestApplyStatus==="16") }]}
      />

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
      />
    </Box>
  );
};

export default SCRW160007;
